// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7O1iT","clinicsSelect":"styles_clinicsSelect__BGuDN"};